import React from "react";

const EyeOpenedIcon = (props: any) => {
  return (
    <svg
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.26529 16.7581L4.29362 16.6665L4.40741 16.6837C5.4306 13.3783 9.02504 11.0501 13.1679 11.0501C15.1731 11.0501 17.0712 11.5836 18.6581 12.5919L18.6581 12.5919C20.184 13.5607 21.3159 14.9311 21.8502 16.4457L21.8881 16.5529L21.9952 16.5151L22.5609 16.3155L22.668 16.2777L22.6302 16.1705C22.0328 14.4758 20.7784 12.9581 19.1018 11.8933C17.3801 10.7994 15.3274 10.2223 13.1679 10.2223C8.68858 10.2223 4.75364 12.7678 3.61703 16.4387L3.58341 16.5473L3.69201 16.5809L4.26529 16.7581Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
      <path
        d="M13.0543 22.3825H13.0811L13.0822 22.3819C14.0546 22.3791 15.0269 22.225 15.9877 21.9212L15.9534 21.8128L15.9877 21.9212C18.5672 21.1052 20.1554 19.5051 20.2268 19.4325L20.3066 19.3513L20.2253 19.2717L19.7965 18.8517L19.7162 18.773L19.6367 18.8525L19.6365 18.8526C19.6166 18.8726 18.0994 20.3922 15.7149 21.1399C14.3225 21.5763 12.9087 21.6687 11.5113 21.4152C9.75736 21.0965 8.01305 20.2277 6.3268 18.8248L6.23945 18.7521L6.16677 18.8394L5.78277 19.3009L5.71007 19.3882L5.79745 19.4609C7.59301 20.9545 9.47115 21.8894 11.3798 22.2323L11.3799 22.2323C11.9362 22.3322 12.4949 22.3825 13.0543 22.3825ZM13.0543 22.2688C12.5018 22.2688 11.9498 22.2192 11.3999 22.1205L13.0554 22.2683L13.0543 22.2688Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
      <path
        d="M22.528 9.46652L22.4439 9.39013L22.3675 9.47426L19.4979 12.6345L19.4215 12.7187L19.5056 12.7951L19.9498 13.1984L20.034 13.2748L20.1104 13.1907L22.98 10.0304L23.0564 9.94625L22.9722 9.86986L22.528 9.46652Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
      <path
        d="M18.3904 6.72204L18.2882 6.67248L18.2386 6.77474L16.1985 10.9836L16.149 11.0859L16.2512 11.1355L16.7911 11.3972L16.8934 11.4467L16.943 11.3445L18.9831 7.13557L19.0326 7.03331L18.9304 6.98375L18.3904 6.72204Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
      <path
        d="M13.5818 6.04395V5.93031H13.4682H12.8682H12.7545V6.04395V10.6372V10.7509H12.8682H13.4682H13.5818V10.6372V6.04395Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
      <path
        d="M8.04062 6.79231L7.99511 6.68818L7.89098 6.7337L7.34121 6.974L7.23708 7.01951L7.28259 7.12364L9.19564 11.5004L9.24116 11.6045L9.34528 11.559L9.89506 11.3187L9.99918 11.2731L9.95367 11.169L8.04062 6.79231Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
      <path
        d="M3.93465 9.47222L3.85777 9.38854L3.77409 9.46543L3.33229 9.8714L3.24862 9.94829L3.32551 10.032L6.22968 13.1924L6.30657 13.2761L6.39024 13.1992L6.83204 12.7933L6.91571 12.7164L6.83883 12.6327L3.93465 9.47222Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
      <path
        d="M14.1072 20.3753H14.2208V20.3729C16.0994 20.3127 17.6092 18.7657 17.6092 16.8727C17.6092 14.9418 16.0381 13.3707 14.1072 13.3707C13.0975 13.3707 12.1369 13.8071 11.4712 14.5669L11.3963 14.6524L11.4818 14.7273L11.9334 15.1228L12.0189 15.1976L12.0937 15.1122C12.6024 14.5318 13.336 14.1986 14.1072 14.1986C15.5821 14.1986 16.7819 15.3984 16.7819 16.8733C16.7819 18.3482 15.5821 19.548 14.1072 19.548C13.4416 19.548 12.8044 19.3021 12.312 18.8563L12.2278 18.7801L12.1515 18.8643L11.749 19.3088L11.6727 19.3931L11.7569 19.4693C12.4018 20.0533 13.2363 20.3753 14.1072 20.3753Z"
        fill="currentColor"
        stroke="currentColor"
        stroke-width="0.227273"
      />
    </svg>
  );
};

export default EyeOpenedIcon;
